<button class="siguiente siguiente-{{direccion}}" (click)="clickEvent()" 
         [ngClass]="{'btn-simple': estilo == 'simple', 'btn-border' : estilo == 'border', 'btn-large' : estilo == 'large' }"
         >
    <span class="icono-izquierda" *ngIf="direccion == 'back'">&#9664;</span>
    <span class="texto-centro" [ngClass]="direccion == 'next' ? 'flecha-derecha' : 'flecha-izquierda'" >{{texto}}</span>
    <span class="icono-derecha" *ngIf="direccion == 'next'">&#10148;</span>
    <span class="icono-spinner" *ngIf="spinner"><mat-spinner diameter="20"></mat-spinner></span>
</button>